import type { RequiredTranslatable } from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import { z } from "zod";

const agendaPreset_dynamicTimes = [
    "yesterday",
    "today",
    "tomorrow",
    "day-after-tomorrow",
    "friday",
    "saturday",
    "sunday",
    "weekend", // this weekend
    "next-weekend",
    "week", // this week
    "next-week",
] as const;

const agendaPreset_dynamicTimeMeta: Record<
    AgendaPreset_DynamicTime,
    RequiredTranslatable
> = {
    "day-after-tomorrow": translation({
        en: "Day after tomorrow",
        sv: "I övermorgon",
    }),
    friday: translation({
        en: "Friday",
        sv: "Fredag",
    }),
    "next-week": translation({
        en: "Next week",
        sv: "Nästa vecka",
    }),
    "next-weekend": translation({
        en: "Next weekend",
        sv: "Nästa helg",
    }),
    saturday: translation({
        en: "Saturday",
        sv: "Lördag",
    }),
    sunday: translation({
        en: "Sunday",
        sv: "Söndag",
    }),
    today: translation({
        en: "Today",
        sv: "Idag",
    }),
    tomorrow: translation({
        en: "Tomorrow",
        sv: "Imorgon",
    }),
    week: translation({
        en: "This week",
        sv: "Denna vecka",
    }),
    weekend: translation({
        en: "This weekend",
        sv: "Till helgen",
    }),
    yesterday: translation({
        en: "Yesterday",
        sv: "Igår",
    }),
};

/**
 * Dynamisk tid för agenda tillval
 *
 * Med dynamisk tid i detta fallet menas att tiden är relativ till nuvarande tid.
 * Exempelvis "today" är dagens datum, "tomorrow" är morgondagens datum, "week" är veckans datum, "next-week" är nästa veckas datum.
 */
const agendaPreset_dynamicTimeZodEnum = z.enum(agendaPreset_dynamicTimes);

/**
 * Dynamisk tid för agenda tillval
 *
 * Med dynamisk tid i detta fallet menas att tiden är relativ till nuvarande tid.
 * Exempelvis "today" är dagens datum, "tomorrow" är morgondagens datum, "week" är veckans datum, "next-week" är nästa veckas datum.
 */
type AgendaPreset_DynamicTime = (typeof agendaPreset_dynamicTimes)[number];

export {
    agendaPreset_dynamicTimeMeta,
    agendaPreset_dynamicTimes,
    agendaPreset_dynamicTimeZodEnum,
};
export type { AgendaPreset_DynamicTime };
